import { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { LOGO_FULL } from "@/lib/constants";
import { Loader2, MailCheck, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

import { tx, lz } from "@/i18n";
export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="w-full max-w-sm animate-fade-up">
        <Link to="/login" className="inline-flex items-center mb-8">
          <img src={LOGO_FULL} alt={tx("Costa Key")} className="h-11 w-auto object-contain" />
        </Link>

        {sent ? (
          <div data-testid="forgot-sent">
            <span className="grid place-items-center h-12 w-12 rounded-full bg-primary/10 text-primary mb-4">
              <MailCheck className="h-6 w-6" />
            </span>
            <h1 className="font-display font-bold text-2xl tracking-tight">{tx("Controleer je e-mail")}</h1>
            <p className="text-muted-foreground mt-2">
              {tx("Als er een account bestaat met dit e-mailadres, hebben we een link gestuurd om je wachtwoord opnieuw in te stellen. De link is 1 uur geldig.")}
            </p>
            <Link to="/login" className="inline-flex items-center gap-1.5 text-primary font-semibold mt-6" data-testid="back-to-login-link">
              <ArrowLeft className="h-4 w-4" /> {tx("Terug naar inloggen")}
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} data-testid="forgot-form">
            <h1 className="font-display font-bold text-3xl tracking-tight">{tx("Wachtwoord vergeten?")}</h1>
            <p className="text-muted-foreground mt-1 mb-6">{tx("Vul je e-mailadres in en we sturen je een herstellink.")}</p>
            <div>
              <Label htmlFor="email">{tx("E-mailadres")}</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" data-testid="forgot-email-input" />
            </div>
            <Button type="submit" disabled={loading} className="w-full mt-6 bg-primary hover:bg-primary/90" data-testid="forgot-submit-btn">
              {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />} {tx("Stuur herstellink")}
            </Button>
            <Link to="/login" className="inline-flex items-center gap-1.5 text-sm text-muted-foreground mt-6 hover:text-foreground" data-testid="back-to-login-link">
              <ArrowLeft className="h-4 w-4" /> {tx("Terug naar inloggen")}
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
